<script>
import GamesByTagsBoxConnected from './GamesByTagsBoxConnected.vue';
import GamesFilteredBoxConnected from './GamesFilteredBoxConnected.vue';

export default {
  functional: true,
  render (h, { parent, data }) {
    const isFiltersEnabled = parent.$store.state.launcher.isFiltersEnabled;
    const component = isFiltersEnabled
      ? GamesFilteredBoxConnected
      : GamesByTagsBoxConnected;
    const vNode = h(component, data);
    return vNode;
  },
};
</script>
